import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollManager } from './ScrollManager';
import { ProjectDrawer } from '../projects/ProjectDrawer';
import { ProjectDrawerProvider } from '../../contexts/ProjectDrawerContext';
export function Layout() {
  return <ProjectDrawerProvider data-id="element-310" data-mp="305v5633w4knb">
      <div className="flex min-h-screen w-full flex-col bg-charcoal" data-id="element-311" data-mp="3064qhddzq3mo">
        <a href="#main" className="sr-only z-[100] bg-brand-action px-4 py-3 font-semibold text-white focus:not-sr-only focus:fixed focus:left-4 focus:top-4" data-id="element-312" data-mp="353501ya1toij">
          Skip to content
        </a>
        <ScrollManager data-id="element-313" data-mp="3ezq7srdgddq2" />
        <Header data-id="element-314" data-mp="3j3o64zuyeki2" />
        <main id="main" tabIndex={-1} className="flex-1 outline-none" data-id="element-315" data-mp="3j24nx3pqlzdn">
          <Outlet data-id="element-316" data-mp="1kntawiw8rfnm" />
        </main>
        <Footer data-id="element-317" data-mp="1kouy1lqj7slp" />
      </div>
      <ProjectDrawer data-id="element-318" data-mp="1kpmic0eoi3wo" />
    </ProjectDrawerProvider>;
}